export default {
  "pl": {
    "signature": {
      "actions": {
        "clearSignature": "Wyczyść podpis",
        "edit": "Edytuj",
        "request": "Wymagaj podpisu",
        "save": "Zapisz",
        "sign": "Podpisać"
      },
      "labels": {
        "add": "Dodaj",
        "add_customer_signatures": "Przed zapisaniem musisz dodać podpisy klientów.",
        "add_team_member_signatures": "Przed zapisaniem musisz dodać podpisy członków zespołu.",
        "all_customers_signed": "Wszyscy żądani nabywcy domów już podpisali. Dokumenty muszą zostać podpisane przez przedstawicieli {client_name}, a propozycja zostanie zatwierdzona po ich podpisaniu. Nie musisz nic więcej robić.",
        "browserNotSupported": "Wykryliśmy, że przeglądarka na twoim urządzeniu mobilnym może nie wspierać podpisów elektronicznych. W razie problemów zmień przeglądarkę lub urządzenie. Możesz też przesłać dokument podpisany tradycyjnie.",
        "customer_signatories": "Sygnatariusze klienta",
        "customers_left_to_sign": "1 klient musi podpisać | {customers_left_to_sign} klientów musi się podpisać",
        "customers_required_to_sign": "Jeszcze 1 nabywca domu musi podpisać dokumenty. | {customers_left_to_sign} więcej nabywców domów musi podpisać dokumenty.",
        "customers_signed_names": "Klienci już podpisani: {names}",
        "documents_read": "Potwierdzam zapoznanie się ze wszystkimi dokumentami i chcę je podpisać.",
        "documents_to_sign": "Dokumenty do podpisania",
        "draw_signature": "Złóż swój podpis poniżej",
        "employee_signatories": "{client_name} sygnatariusze",
        "employees_required_to_sign": "Jeszcze 1 członek zespołu musi podpisać dokumenty. | {employees_left_to_sign} więcej członków zespołu musi podpisać dokumenty",
        "employees_signed_names": "Członkowie zespołu już podpisani: {names}",
        "empty_signature_warning": "Najpierw złóż swój podpis.",
        "marked": "Wyznaczono miejsce na podpis",
        "multiple_signatories_info": "Dokument ten zostanie podpisany przez wielu sygnatariuszy. Podaj swoje imię i nazwisko przed podpisaniem, aby {client_name} mógł śledzić, kto się podpisał.",
        "next": "Dalej",
        "no_signature_indicators_warning": "Określ, gdzie ma znaleźć się podpis, klikając odpowiednią stronę lub strony.",
        "ok": "ok",
        "original": "Oryginał",
        "page": "strona",
        "place_signature_subtitle": "Kliknij stronę lub strony, na których ma się znaleźć podpis elektroniczny klienta",
        "place_signature_title": "Wyznacz miejsce na podpis",
        "read_documents": "Przeczytaj następujące dokumenty przed ich podpisaniem",
        "remove": "Usuń",
        "requesting_signage": "Żądanie oznakowania od",
        "sign": "Podpisz",
        "signatories_for_all_documents": "Liczba sygnatariuszy dotyczy wszystkich dokumentów. Zmiana go usunie wszystkie podpisy i będziesz musiał je ponownie dodać.",
        "signatureNotPossible": "Podpis elektroniczny nie jest dostępny w plikach tego typu",
        "signatures_pending_from_client": "Oczekujące podpisy od zespołu {client_name}",
        "signed": "Podpisano",
        "signed_progress": "Podpisano: {already_signed_count} z {all_required_to_sign_count}",
        "specifyWhereToSign": "Wyznacz miejsce na podpis",
        "team_member": "Członek zespołu",
        "team_member_signature_warning": "Będziesz mógł poprosić o oznakowanie członków zespołu po tym, jak poprosisz o oznakowanie od klientów.",
        "thank_you_for_signing": "Dziękuję za podpisanie.",
        "toBeSigned": "Do podpisu"
      }
    }
  }
}
